import { useEffect, useState } from "react";
import { Volume2 } from "lucide-react";

// "Turn up the volume" pill shown once, 3s into playback, for 5s.
export default function VolumeHint({ playing, currentTime, en }) {
  const [phase, setPhase] = useState("idle"); // idle | shown | done

  useEffect(() => {
    if (phase === "idle" && playing && currentTime >= 3) setPhase("shown");
  }, [phase, playing, currentTime]);

  useEffect(() => {
    if (phase !== "shown") return;
    const t = setTimeout(() => setPhase("done"), 5000);
    return () => clearTimeout(t);
  }, [phase]);

  return (
    <div
      className={`absolute top-10 inset-x-0 z-40 flex justify-center pointer-events-none transition-[opacity,transform] duration-500 ${phase === "shown" ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-2"}`}
      aria-hidden={phase !== "shown"}
      data-testid="video-volume-hint"
    >
      <div className="flex items-center gap-2 bg-black/75 backdrop-blur-md text-white text-[13px] font-bold px-4 py-2 rounded-full shadow-lg" dir={en ? "ltr" : "rtl"}>
        <Volume2 className="w-4 h-4 text-brand-400 animate-pulse" />
        {en ? "Turn up the volume to hear it" : "ارفع الصوت عشان تسمع الشرح"}
      </div>
    </div>
  );
}
